<template>
  <ui-content title="Agencia Reporte">
    <ui-card v-if="loading.view == false">
      <div class="row form-row align-items-center mb-2">
        <div class="col-lg-3">
          <label for="" class="form-label">Agencia:</label>
          <select class="form-control form-control-sm" v-model="form.agencia">
            <option
              v-for="item in containers.agencias"
              :key="item.idAgencia"
              :value="item.idAgencia"
              >{{ item.nombre }}
            </option>
          </select>
        </div>
        <div class="col-lg-3">
          <label for="" class="form-label">Fecha Inicio:</label>
          <date-picker
            v-model="form.fecha_inicio"
            format="DD-MM-YY"
            value-type="YYYY-MM-DD"
            input-class="form-control form-control-sm"
            :editable="false"
          ></date-picker>
        </div>
        <div class="col-lg-3">
          <label for="" class="form-label">Fecha Fin:</label>
          <date-picker
            v-model="form.fecha_fin"
            format="DD-MM-YY"
            value-type="YYYY-MM-DD"
            input-class="form-control form-control-sm"
            :editable="false"
          ></date-picker>
        </div>
      </div>
      <div class="form-group">
        <button
          class="btn btn-primary"
          @click="onSearch"
          :disabled="loading.search"
        >
          Buscar
        </button>
        <button
          v-if="reporteFiltrado.length"
          class="btn btn-outline-secondary ml-2"
          @click="onPrint"
        >
          Imprimir
        </button>
      </div>
      <hr />
      <b-table-lite
        bordered
        small
        responsive
        :items="reporteFiltrado"
        :fields="containers.tableFields"
        head-variant="light"
      >
        <template v-slot:cell(fecha)="{ item: { fecha } }">
          {{ fecha | date }}
        </template>
      </b-table-lite>
    </ui-card>
  </ui-content>
</template>
<script>
import { BTableLite } from "bootstrap-vue";
import DatePicker from "vue2-datepicker";
import pdfReporteAgencia from "@/modules/reportes/pdf/pdfReporteAgencia.js";

export default {
  components: {
    DatePicker,
    BTableLite
  },
  data() {
    return {
      form: {
        agencia: "",
        fecha_inicio: "",
        fecha_fin: ""
      },
      reportes: [],
      containers: {
        agencias: [],
        tableFields: [
          "tabla",
          {
            key: "codigo",
            label: "Cód."
          },
          "fecha",
          "pasajero",
          "servicio",
          {
            key: "tipoServicio",
            label: "Tipo Servicio"
          },
          {
            key: "pax",
            label: "PAX"
          },
          {
            key: "chd",
            label: "CHD"
          },
          "idioma",
          {
            key: "codLiquidacion",
            label: "Cód. Liquid."
          },
          {
            key: "costoLiquidacion",
            label: "Costo. Liquid."
          },
          {
            key: "usuarioCreador",
            label: "Usuario Creador"
          }
        ]
      },
      loading: {
        view: true,
        search: false
      }
    };
  },
  created() {
    const vm = this;

    vm.axios.get("/agencias").then(response => {
      vm.containers.agencias = response.data.content;
      vm.loading.view = false;
    });
  },
  computed: {
    usuarios() {
      const vm = this;
      let usuarios = vm.reportes.map(item => item.usuarioCreador);
      usuarios = [...new Set(usuarios)];
      return usuarios;
    },
    reporteFiltrado() {
      return this.reportes;
    },
    agencia() {
      if (!this.form.agencia) return "";
      return (
        this.containers.agencias.find(
          item => item.idAgencia == this.form.agencia
        )?.nombre || ""
      );
    }
  },
  methods: {
    onSearch() {
      const vm = this;

      if (!(vm.form.agencia && vm.form.fecha_inicio && vm.form.fecha_fin)) {
        return vm.$toast.fire("Completa todos los campos", "", "warning");
      }

      if (vm.$dayjs(vm.form.fecha_inicio) > vm.$dayjs(vm.form.fecha_fin)) {
        return vm.$toast.fire(
          "Fecha inicio no puede ser mayor a fecha fin",
          "",
          "warning"
        );
      }

      vm.reportes = [];
      vm.loading.search = true;

      vm.axios
        .get(`/reportes/agencias/${vm.form.agencia}`, {
          params: vm.form
        })
        .then(response => {
          vm.reportes = response.data.content;
        })
        .finally(() => {
          vm.loading.search = false;
        });
    },
    onPrint() {
      const vm = this;

      const registros = this.reporteFiltrado.map(item => ({
        ...item,
        fecha: vm.$options.filters.date(item.fecha),
        hora: vm.$options.filters.date(item.horaTicket, "HH:mm:ss", "HH:mm")
      }));

      pdfReporteAgencia({
        registros,
        header: {
          agencia: this.agencia,
          fecha_inicio: vm.$options.filters.date(vm.form.fecha_inicio),
          fecha_fin: vm.$options.filters.date(vm.form.fecha_fin)
          
        },
        userMark: vm.$store.state.user,
        dateMark: vm.$dayjs().format("DD-MM-YY HH:mm")
      });
    }
  }
};
</script>
